import { COOKIE_SC_ATKN } from "../constants/storage";
import { Cookie } from "../services/storage";
import { UtilsDateTime } from "./UtilsDateTIme";

export const REQUEST_RESTRICTED_13_COUNTRIES = ["USA"];
export const REQUEST_RESTRICTED_14_COUNTRIES = ["KOR"];

export const UtilsUser = {
  isUserLoggedIn: () => {
    return !!Cookie.get(COOKIE_SC_ATKN);
  },

  isUserRestricted: (countryCode: string, userBirthdate?: string) => {
    if (
      REQUEST_RESTRICTED_13_COUNTRIES.indexOf(countryCode) >= 0 &&
      userBirthdate
    ) {
      const userAge = UtilsUser.getUserAge(userBirthdate);
      if (userAge < 13) return true;
    }

    if (
      REQUEST_RESTRICTED_14_COUNTRIES.indexOf(countryCode) >= 0 &&
      userBirthdate
    ) {
      const userAge = UtilsUser.getUserAge(userBirthdate);
      if (userAge < 14) return true;
    }

    return false;
  },
  getUserAge: (date: string) => {
    const now = new Date();
    let birthDate = UtilsDateTime.parseDate(date, true);

    // get time diff
    let diff = (now.getTime() - birthDate.getTime()) / 1000;

    // get diff in years for age
    diff = Math.floor(diff / (365.25 * 24 * 60 * 60));

    return diff;
  },
};
